import React from 'react'
import './styles.scss'

interface Props {
  className?: string
pos:number
  sex: 'f' | 'm'
}

export const Candle = ({ className, sex,pos }: Props) => {
  const rnd = Math.round(Math.random() * 6)
  return (
    <div
      className={
        'Candle ' + className + (sex === 'f' ? ` red _${rnd}` : ` blue _${rnd}`)
      }
    >
      <div className='innerframe'></div>
    </div>
  )
}
